import { Flex } from 'antd';
import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import { Page } from '../../../../../shared/ui/Page';
import { useUpdateShopDetailsMutation } from '../../shops/service/shops';
import { ShopDetailsType } from '../../shops/service/shop.interface';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { IntegrationEmailExample } from '../components/IntegrationEmailExample';
import { Save } from '../../../widgets/Save';
import { initialValues } from '../utils/options';
import { IntegrationEmailForm } from '../components/IntegrationEmailForm';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';
import { IntegrationEmailProps } from '../service/integration-email.interface';
import { useAppSelector } from '../../../../../store';

export const IntegrationEmailPage = () => {
    const current = useAppSelector(selectShopCurrent);

    const [updateShopDetails, { isLoading, isSuccess, isError, error }] =
        useUpdateShopDetailsMutation();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, {
        message: 'Отправка оповещений на почту о заказах успешно настроена',
    });

    useEffect(() => {
        if (current.details?.integration_email) {
            formik.setFieldValue('value', current.details?.integration_email);
        }
    }, [current.details?.integration_email]);

    const handleSave = async (values: IntegrationEmailProps) => {
        const payload = {
            type: ShopDetailsType.integrationEmail,
            ...values,
        };

        await updateShopDetails({
            id: current.id,
            body: payload,
        });
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: handleSave,
    });

    const disabled = formik?.values?.value === '';

    return (
        <Page isBackButton title='Настройка рассылки заказов'>
            <Flex vertical gap={16}>
                <IntegrationEmailForm formik={formik} />
                <IntegrationEmailExample />

                <Save
                    onSave={() => handleSave(formik.values)}
                    disabled={disabled}
                    loading={isLoading}
                />
            </Flex>
        </Page>
    );
};
